module.exports = __webpack_public_path__ + "static/media/CalculatorBusinessHero.db556512.svg";